import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Circle, Rect } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function GenerateOTPIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (

    <Svg
      {...svgProps}
      viewBox="0 0 52 52">

      <G id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <G id="5.3-Profile" transform={{translate: '-223.000000, -201.000000'}}>
          <G id="OTP-Profile" transform={{translate: '224.000000, 202.000000'}}>
            <Circle id="Oval" stroke="#FFFFFF" cx="25" cy="25" r="25"></Circle>
            <Rect id="Rectangle-14" stroke="#FFFFFF" x="14.6304348" y="9.19565217" width="20.7391304"
                  height="30.5217391" rx="2"></Rect>
            <Rect id="Rectangle-15" stroke="#FFFFFF" x="14.6304348" y="15.7173913" width="20.7391304" height="1"></Rect>
            <Rect id="Rectangle-15" stroke="#FFFFFF" x="21.1521739" y="12.4565217" width="7.69565217" height="1"></Rect>
            <Rect id="Rectangle-15" stroke="#FFFFFF" x="21.1521739" y="36.3695652" width="7.69565217" height="1"></Rect>
            <Rect id="Rectangle-15" stroke="#FFFFFF" x="14.6304348" y="33.1086957" width="20.7391304" height="1"></Rect>
          </G>
        </G>
      </G>
    </Svg>
  );
}

GenerateOTPIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

GenerateOTPIcon.defaultProps = {
  height: 50,
  width: 50,
};

export default pure(GenerateOTPIcon);
